"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
export class DeviceFormatter {
  static getInfo() {
    return __async(this, null, function* () {
      let response = yield API.get(`api://base.local/system/devices`);
      let device_info = yield this.formatInfo(response.data);
      let device_mini = this.formatnull(response.data.machine_id);
      let device_name = this.formatnull(response.data.host.name);
      return {
        device_info,
        device_mini,
        device_name
      };
    });
  }
  static formatInfo(data) {
    return __async(this, null, function* () {
      let os_info = {
        graphics_controllers_vendor: "",
        graphics_controllers_model: "",
        os_arch: "",
        cpu_vendor: "",
        cpu_brand: "",
        os_release: "",
        os_serial: "",
        os_info_distro: "",
        network_iface_name: "",
        network_mac: "",
        network_mac_all: [],
        mem_total: 0,
        detail: {}
      };
      if (this.formatnull(data.os) !== "") {
        os_info.os_arch = this.formatnull(data.os.arch);
      }
      if (this.formatnull(data.cpu) !== "") {
      }
      if (this.formatnull(data.memory) !== "") {
        os_info.mem_total = this.formatnull(data.memory.total);
      }
      os_info.detail = data;
      return os_info;
    });
  }
  static getmacall(data) {
    let mac_all = [];
    for (let item of data) {
      if (item.hasOwnProperty("mac")) {
        mac_all.push(item.mac);
      }
    }
    return mac_all;
  }
  static formatnull(data) {
    if (data !== "" && data !== null && data !== void 0) {
      return data;
    }
    return "";
  }
  static formatarr(data) {
    if (data.length > 0) {
      return data;
    }
    return [
      {}
    ];
  }
}
